import { Box, COLOR_PALETTE, Flex, Icon, Text, desktopFirstMediaQuery } from '@inflearn/ds-react';
import { faStar } from '@inflearn/pro-solid-svg-icons';
import { useTranslation } from 'next-i18next';

import { formatCommaNumber } from '../../../utils/format/number';

type Props = {
  reviewCount: number;
  reviewAverage: string;
};

export function ReviewInformation({ reviewCount, reviewAverage }: Props) {
  const { t } = useTranslation();

  return (
    <Flex
      gap={10}
      py={16}
      css={{
        borderTop: `1px solid ${COLOR_PALETTE.gray[2]}`,
        borderBottom: `1px solid ${COLOR_PALETTE.gray[2]}`,
        '& > div': {
          flex: 1,
        },

        [desktopFirstMediaQuery.tablet]: {
          marginTop: 0,
          textAlign: 'center',
          justifyContent: 'space-around',
        },
      }}
    >
      <Box>
        <Text size="xs" color="gray.6" weight={500} align={'center'}>
          {t('수강평 작성수')}
        </Text>
        <Text size="sm" weight={600} color="black" align={'center'}>
          {reviewCount === 0 ? '-' : formatCommaNumber(reviewCount)}
        </Text>
      </Box>
      <Box>
        <Text size="xs" color="gray.6" weight={500} align={'center'}>
          {t('평균평점')}
        </Text>
        <Text size="sm" weight={600} color="black" align={'center'}>
          {reviewAverage === '0.0' ? null : <Icon icon={faStar} size="xs" color="yellow.6" />}
          <Text component="span" css={{ verticalAlign: 'middle' }} ml={2}>
            {reviewAverage === '0.0' ? '-' : reviewAverage}
          </Text>
        </Text>
      </Box>
    </Flex>
  );
}
